import React from "react";
// ANT DESIGN COMPONENTS
import { Button } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import { updateLiftRefreshTable } from "../../../redux/lifts/liftSlice";
// AUTHORIZATION
import validatePermission from "../../../utils/validatePermissions";
// INTERFACES
import { RootState } from "../../../app/store";

function LiftsHeader() {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const dispatch = useDispatch();
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { permissions } = useSelector((state: RootState) => state.user);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const handleReloadPage = () => {
		dispatch(updateLiftRefreshTable(true));
		setTimeout(() => {
			dispatch(updateLiftRefreshTable(false));
		}, 1000);
	};

	return (
		<div className='generalStyles__pageHeader'>
			{validatePermission("lifts-view", permissions) && (
				<div className='generalStyles__mlFix mt-1'>
					<Button
						className='buttonStyle__8'
						icon={<FontAwesomeIcon icon={faArrowsRotate} className='generalStyles__mrFix' />}
						onClick={() => {
							handleReloadPage();
						}}
					>
						{t("edgeManagement.lifts.refreshTable")}
					</Button>
				</div>
			)}
		</div>
	);
}

export default LiftsHeader;
